const Arrow = () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fillRule="evenodd" clipRule="evenodd" d="M18.25 13H2v-2h16.25L12 4.462 13.397 3 22 12l-8.603 9L12 19.538 18.25 13z" fill="#000" />
    </svg>
);
export default Arrow;
